import { __awaiter } from "tslib";
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import { WikiRecommendationsVariant } from './interfaces/WikiRecommendationsVariants';
import renderOnMobile from './helpers/renderOnMobile';
import renderOnRightRail from './helpers/renderOnRightRail';
import renderNewModule from 'pathfinder/modules/OnWikiRecommendations/helpers/renderNewModule';
export const getOnWikiRecommendationsModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const moduleProps = buildModuleProps(moduleConfig, {});
    const { log } = moduleProps;
    try {
        const getElement = () => __awaiter(void 0, void 0, void 0, function* () {
            switch (moduleConfig.config.variant) {
                case WikiRecommendationsVariant.NewJustForYouWidget:
                case WikiRecommendationsVariant.NewOthersLikeYouWidget:
                    yield renderNewModule(moduleConfig);
                    break;
                case WikiRecommendationsVariant.NewOthersLikeYouWidgetControl:
                case WikiRecommendationsVariant.DesktopSameVertical:
                    yield renderOnRightRail(moduleConfig);
                    break;
                case WikiRecommendationsVariant.MobileSameVertical:
                    yield renderOnMobile(moduleConfig);
                    break;
            }
        });
        const render = () => {
            getElement();
            return;
        };
        return {
            render,
        };
    }
    catch (error) {
        log.debug('OnWikiRecommendations error', error);
    }
    return null;
});
